export interface PricingComponent {
  name: string;
  priceInCents: number;
  type: string;
}

export interface Offer {
  cohortId?: number;
  nextPath?: string;
  order: Order;
  orderUrl: string;
  paymentDetails: {
    cardBrand: string;
    cardLast4: string;
    cardName: string;
    paymentMethod: string;
    stripePaymentMethodId: string;
    zipCode: string;
  };
  successPath?: string;
}

export interface Pricing {
  components: PricingComponent[];
  couponCode: string;
  tax: number;
  total: number;
  totalExcludingTax: number;
  zipCode: string;
}

export interface SubscriptionPlan {
  cohortId: number;
  currency: string;
  description: string;
  durationDays: number;
  durationMonths: number;
  id: number;
  initialAmount?: number;
  installmentInterval?: 'week' | 'month';
  installmentIntervalCount?: number;
  name: string;
  planSlug: string;
  priceCents: number;
  slug: string;
}

export interface Order {
  allowInstallments: boolean;
  pricing: Pricing;
  stripeToken?: string;
  subscriptionPlan: SubscriptionPlan;
}

export interface BulkSelfServeFormProps {
  isEuUser: boolean;
  nonprofit: boolean;
  signedIn: boolean;
  stripeToken: string;
  subscriptionPlans: SubscriptionPlan[];
}

export interface SubscriptionFormProps {
  isEuUser: boolean;
  order: Order;
  signedIn: boolean;
  signupMotivators?: boolean;
  twoStepSignup: boolean;
  user?: {
    email: string;
    password: string;
    passwordConfirmation: string;
    termsAndPolicyAccepted: boolean;
  };
}

export interface OrderItem {
  priceCentsPerItem: number;
  purchasable: SubscriptionPlan;
  purchasableCount: number;
}

export interface BulkSelfServeFormValues {
  _error?: string;
  cardCvc?: string;
  cardExpirationDateMonth?: number;
  cardExpirationDateYear?: number;
  cardName?: string;
  cardNumber?: string;
  email?: string;
  orderItems?: OrderItem[];
  password?: string;
  passwordConfirmation?: string;
  paymentMethod: PaymentMethod;
  paymentStyle?: PaymentStyle;
  purchaseToken?: string;
  signedIn: boolean;
  stripePaymentMethod?: any;
  termsAndPolicyAccepted: boolean;
  zipCode?: string;
}

export interface SubscriptionFormValues {
  _error?: string;
  alipayPaymentUrl?: string; // Used for redirecting to Alipay payment page
  cardCvc?: string;
  cardExpirationDateMonth?: number;
  cardExpirationDateYear?: number;
  cardName?: string;
  cardNumber?: string;
  cohortId?: number;
  email?: string;
  password?: string;
  passwordConfirmation?: string;
  paymentMethod: PaymentMethod;
  paymentStyle?: PaymentStyle;
  planId?: number;
  pricing: Pricing;
  purchaseToken?: string;
  signedIn: boolean;
  stripePaymentMethod?: any;
  termsAndPolicyAccepted: boolean;
  zipCode?: string;
}

export enum PaymentStyle {
  INSTALLMENTS = 'INSTALLMENTS',
  FULLPAYMENT = 'FULLPAYMENT'
}

export enum PaymentMethod {
  ALIPAY = 'stripe_alipay',
  CREDITCARD = 'credit_card',
  PAYPAL = 'paypal_express',
  STRIPE = 'stripe',
  STRIPE_PAYMENT_REQUEST = 'stripe_payment_request'
}

export interface CreateSubscriptionResponse {
  actionRequired?: {
    amount?: number;
    clientSecret: string;
    paymentMethodId?: string;
    type: 'confirmSetup' | 'confirmPayment' | 'completePaymentRequest';
  };
  nextUrl?: string;
}
